import { useTranslation } from 'react-i18next';
import { NodeWithoutDescription } from '../modules/material/_api/TableOfContentsApi';

/**
 * @deprecated Only used in old portaal
 */
export const getNodeDescription = (node: NodeWithoutDescription, t: ReturnType<typeof useTranslation>['t']) => {
  if (node.id === 'general') return t('TOC_GENERAL');

  return node.displayPrefix ? `${node.prefix} ${node.title}` : node.title;
};

/**
 * @deprecated Only used in old portaal
 */
export const getFullHierarchyDescription = (
  hierarchy: NodeWithoutDescription[],
  t: ReturnType<typeof useTranslation>['t'],
) => {
  const descriptions = hierarchy.map(x => getNodeDescription(x, t));

  return descriptions.join(': ');
};

type Hierarchy = Omit<NodeWithoutDescription, 'displayPrefix'> & { displayPrefix?: boolean };

export const getDescriptionOfNode = (node: Hierarchy, t: ReturnType<typeof useTranslation>['t']) => {
  if (node.id === 'general') return t('TOC_GENERAL');

  const displayPrefix = node.displayPrefix ?? !!node.prefix;

  return displayPrefix ? `${node.prefix} - ${node.title}` : node.title;
};

export const getFullHierarchyDescriptionOfNode = (
  hierarchy: Hierarchy[],
  t: ReturnType<typeof useTranslation>['t'],
) => {
  const descriptions = hierarchy.map(x => getDescriptionOfNode(x, t));

  return descriptions.join(': ');
};
